// extracted by mini-css-extract-plugin
export default {"video":"styles_video__ZHf91","content":"styles_content__E68MH","container":"styles_container__0Zvc5","nextPageBtn":"styles_nextPageBtn__2Db2K"};